import React from 'react';
import { Settings, CalendarCheck, Truck, Zap } from 'lucide-react';
import { BrandChips } from './BrandChips';
export function ServicesSection() {
  const services = [{
    icon: <Settings className="w-6 h-6 text-white" data-id="element-153" />,
    title: 'Reparación de equipos pesados',
    description: 'Diagnóstico y reparación completa de montacargas, tractores, elevadores y más, directamente en tu planta o depósito.'
  }, {
    icon: <CalendarCheck className="w-6 h-6 text-white" data-id="element-154" />,
    title: 'Mantenimiento programado',
    description: 'Planificamos las paradas de mantenimiento para que tu operación nunca se detenga por sorpresa. Mediana y alta complejidad.'
  }, {
    icon: <Truck className="w-6 h-6 text-white" data-id="element-155" />,
    title: 'Servicio in situ y colectivo',
    description: 'Vamos a tu empresa con todo el equipo. Sin traslados, sin pérdida de tiempo, sin excusas.'
  }, {
    icon: <Zap className="w-6 h-6 text-white" data-id="element-156" />,
    title: 'Atención de fallas inmediatas',
    description: 'Falla urgente: la atendemos sin demoras. Sabemos que cada minuto parado produce pérdidas reales.'
  }];
  const brands = ['Kalmar', 'Bellotti', 'Taylor', 'Clark', 'Hyster', 'Caterpillar', 'John Deere', 'Komatsu'];
  return <section className="py-20 bg-white" data-id="element-157">
      <div className="container mx-auto px-4" data-id="element-158">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-159">
          <span className="inline-block px-4 py-1.5 rounded-full bg-lightBg text-primary font-semibold text-sm mb-4" data-id="element-160">
            Nuestros servicios
          </span>
          <h2 className="text-gray-900 font-heading font-bold" data-id="element-161">
            Todo lo que tu equipo necesita, en un solo lugar
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-x-12 gap-y-10 max-w-5xl mx-auto mb-16" data-id="element-162">
          {services.map((service, index) => <div key={index} className="flex gap-6 items-start" data-id="element-163">
              <div className="flex-shrink-0 w-14 h-14 bg-primary rounded-xl flex items-center justify-center shadow-md" data-id="element-164">
                {service.icon}
              </div>
              <div data-id="element-165">
                <h3 className="text-xl font-bold text-gray-900 mb-2 font-heading" data-id="element-166">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-[17px]" data-id="element-167">
                  {service.description}
                </p>
              </div>
            </div>)}
        </div>

        <div className="max-w-4xl mx-auto text-center border-t border-gray-100 pt-10" data-id="element-168">
          <p className="text-sm text-gray-500 font-medium uppercase tracking-wider mb-6" data-id="element-169">
            Especialistas en marcas líderes
          </p>
          <div className="flex justify-center" data-id="element-170">
            {/* Reusing BrandChips but overriding styles for light background */}
            <div className="flex flex-wrap justify-center gap-2" data-id="element-171">
              {brands.map((brand, index) => <span key={index} className="px-4 py-1.5 text-sm font-medium text-primary bg-lightBg rounded-full border border-primary/10" data-id="element-172">
                  {brand}
                </span>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}